<template>
  <div class="satellite">

    <div class="content">

      <!-- <app-btn to="/dashboard/satellite/active">Active fields</app-btn> -->
      <router-view></router-view>
    </div>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.satellite {
  display: flex;
  flex-direction: column;

  .content {
    height: 100%;


  }
}
</style>
